import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const nomination = {
	title: 'nominace',
	sellersInCampaign: 'Obchodníci v kampani:',
	discardedSellersInCampaign: 'Vyřazení z kampaně:',
};

export default Object.assign({}, nomination, createLabeledMessages(nomination));
